









import { defineComponent } from '@vue/composition-api';

const CommonTableFooter = defineComponent({
  // setup() {},
});

export default CommonTableFooter;
